<template>
    <div class="wrapper pr">

        <el-card class="wrap-tree page-box" shadow="never">
            <div slot="header" class="clearfix"><span>员工部门</span>
                <el-button style="float: right; padding: 3px 0" class="pointer" type="text" @click="addDeptButton" v-pms="'addDept'">+ 添加部门</el-button>
            </div>
            <div v-for="(item,index) in data" :key="item.deptId" class="text item employee-dept ">
                <div :class="{active: deptId==item.deptId}">
                    <div @click="handleClick(item)" class="dept">{{item.name}}</div>
                    <el-button class="employee-dept-delete" icon="el-icon-delete"  @click="delDept(item)" v-if="index!=0" v-pms="'delDept'"></el-button>
                    <el-button class="employee-dept-delete" icon="el-icon-edit"  @click="editDeptButton(item)" v-if="index!=0" v-pms="'editDept'"></el-button>
                </div>
            </div>
        </el-card>
        <div class="wrap-form">
            <employee
              ref="table"
              :deptId="deptId">
            </employee>
        </div>
        <el-dialog
          :title="editMsg"
          :visible.sync="dialogFormVisible"
          v-if="dialogFormVisible"
          :modal="false"
          :v-loading="submitting">
            <div class="add-form">
                <el-form
                  ref="form"
                  :model="deptData"
                  label-width="94px"
                  :rules="rules">
                    <el-form-item prop="name" label="部门名称">
                        <el-input v-model="deptData.name" class="el-input"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input class="el-input"
                          type="textarea"
                          :rows="3"
                          placeholder="请输入内容"
                          v-model="deptData.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="width: 100px;">关 闭</el-button>
                <el-button type="primary" @click="submitDept" style="width: 100px;">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { employee } from '../../api'
import Employee from './Employee'
export default {
  name: 'employeeDept',
  components: { 'employee': Employee },
  mounted () {
    this.getTableData()
  },
  data () {
    return {
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      userId: this.$store.state.user.userId,
      data: [],
      deptId: '',
      submitting: false,
      editMsg: '',
      dialogFormVisible: false,
      deptData: {
        name: '',
        deptId: '',
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入部门名称', trigger: 'blur'},
          { max: 32, message: '长度不能超过32个字符', trigger: 'blur' }
        ],
        remark: [
          { message: '请输入备注', trigger: 'blur' },
          { max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async getTableData () {
      this.loading = true
      let { data } = await employee.getDeptList({
        'orgCode': this.orgCode
      })
      this.loading = false
      this.data = data
      this.data.splice(0, 0, {deptId: '', name: '全部'})
    },
    handleClick (data) {
      this.deptId = data.deptId
    },
    submitDept () { // 添加编辑
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.deptData.deptId) {
            this.addDept()
          } else {
            this.editDept()
          }
        } else {
          return false
        }
      })
    },
    async addDept () { // 添加方法
      this.submitting = true
      this.deptData.orgCode = this.orgCode
      this.deptData.createUser = this.userId
      let { code, data, msg } = await employee.addEmployeeDept(this.deptData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '员工部门添加成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '员工部门添加失败'
        })
      }
    },
    async editDept () { // 编辑方法
      this.submitting = true
      let { code, msg } = await employee.editEmployeeDept(this.deptData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '员工部门修改成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '员工部门修改失败'
        })
      }
    },
    addDeptButton () {
      this.editMsg = '添加部门'
      this.deptData = {}
      this.dialogFormVisible = true
    },
    editDeptButton (data) {
      this.editMsg = '编辑部门'
      this.deptData = data
      this.dialogFormVisible = true
    },
    delDept (deptItem) {
      this.$confirm(`确定要删除【${deptItem.name}】吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let { data } = await employee.validIsExist({
          deptId: deptItem.deptId
        })
        if (data) {
          let { code } = await employee.delEmployeeDept({deptId: deptItem.deptId})
          if (code === 0) {
            this.$message({
              type: 'success',
              message: `【${deptItem.name}】删除成功`
            })
            this.getTableData()
          } else {
            this.$message({
              type: 'error',
              message: `【${deptItem.name}】删除失败`
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: `【${deptItem.name}】下面存在员工,不能删除`
          })
        }
      }, err => {
        console.log(err)
      })
    }

  }
}
</script>

<style scoped>
    .add-form {
        margin: 0 auto;
        width: 300px;
    }
    .el-input {
        width: 240px;
    }
    .wrapper {
        display: flex;
    }
    .wrap-tree {
        width: 280px;
        flex-shrink: 0;
        box-sizing: border-box;
    }
    .wrap-form {
        flex-grow: 1;
        margin-left: 10px;
        box-sizing: border-box;
    }
    .pointer:hover  {
        cursor: pointer;
    }
    .employee-dept {
        padding: 8px 0;
        border-bottom: 1px solid #eee;
        /*font-size: 13px;*/
    }
    .employee-dept .active {
        color:#ea5514;
    }
    .employee-dept-delete {
        float: right;
        padding: 4px 2px;
        margin-left: 12px;
        border: none;
        color: #999;
    }
    .dept {
        display: inline-block;
    }
</style>
